"use client";

import {
  CircleFadingArrowUp,
  SparklesIcon,
  Wand2Icon,
  Youtube,
} from "lucide-react";
import posthog from "posthog-js";
import { useAuth } from "@/components/providers/auth-context";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import usePricingModal, { PAYWALL_TYPES } from "@/lib/hooks/use-pricing-modal";
import { useI18n } from "@/locales/client";

export const UpgradeCard = () => {
  const { onOpen } = usePricingModal();
  const { userId } = useAuth();
  const t = useI18n();

  const upgradeCardArr = [
    {
      title: t("upgradeCard.features.fileUploads.title"),
      description: t("upgradeCard.features.fileUploads.description"),
      icon: Wand2Icon,
    },
    {
      title: t("upgradeCard.features.youtubeImports.title"),
      description: t("upgradeCard.features.youtubeImports.description"),
      icon: Youtube,
    },
    {
      title: t("upgradeCard.features.aiTutorChats.title"),
      description: t("upgradeCard.features.aiTutorChats.description"),
      icon: SparklesIcon,
    },
  ];

  return (
    <Card className="bg-[#0077FF0D] rounded-2xl">
      <CardHeader className="flex flex-row items-center justify-between">
        <div className="space-y-1.5">
          <CardTitle className="text-lg font-semibold leading-5">
            {t("upgradeCard.title")}
          </CardTitle>
          <CardDescription className="text-xs leading-4 font-normal">
            {t("upgradeCard.description")}
          </CardDescription>
        </div>
        <Button
          onClick={() => {
            onOpen({
              paywallType: PAYWALL_TYPES.UPGRADE_CARD_STUDYSET_PAGE,
            });
            posthog.capture("paywall_shown", {
              userId,
              paywallType: PAYWALL_TYPES.UPGRADE_CARD_STUDYSET_PAGE,
            });
          }}
          className="text-sm font-noraml flex gap-2 hover:text-brand-primary text-brand-primary h-6"
          variant={"ghost"}
          size={"sm"}
        >
          <CircleFadingArrowUp className="size-4" />
          {t("upgradeCard.upgrade")}
        </Button>
      </CardHeader>
      <CardContent className="hidden md:flex flex-col gap-4">
        {upgradeCardArr.map((item) => (
          <div key={item.title} className="flex items-start gap-2">
            <item.icon className="size-4 text-[#0077FF] mt-1" />

            <div className="space-y-1.5">
              <h6 className="font-medium text-sm leading-3">{item.title}</h6>
              <p className="text-xs font-normal text-muted-foreground">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
